/* eslint-disable no-unused-expressions */
import React from 'react';
import PartnerBanner from './PartnerBanner';
import PartnerProductCatagory from './PartnerProductCatagory';
import ContactWileyBlock from './ContactWileyBlock';
import PartnerProducts from './PartnerProducts';

class Body extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
      bannerTextBlock: undefined,
      partnerResponse: null
    };
  }

  componentDidMount() {
    this.setState({partnerResponse: this.props.PartnerDetailPageResponse})
    const promises = this.props.PartnerDetailBannerComponents && this.props.PartnerDetailBannerComponents.map((block) => {
      block.partner && block.partner.map((item) => {
        this.props.PartnerDetailPageResponse.partner.partnerId === item
            && this.setState({
              bannerTextBlock: block,
            });
      });
    });
    Promise.all(promises).then(() => this.props.PartnerDetailBannerComponents.map((block) => {
      !block.partner && this.state && this.state.bannerTextBlock === undefined
         && this.setState({
           bannerTextBlock: block,
         });
    }));

    this.props.backgroundImages && this.props.backgroundImages !== undefined && this.props.backgroundImages.forEach((image) => {
      this.setState({
        [`bg_${image.acf_fc_layout}`]: image.content,
      });
    });
    window.addEventListener('resize', this.handleWindowSizeChange);
  }
  componentWillUnmount(){
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth })
  }
  componentDidUpdate() {
    if(this.state.partnerResponse === null){
      this.setState({partnerResponse: this.props.PartnerDetailPageResponse})
    }
  }
  changeProduct = (link) => {
    if (link !== window.location.pathname) {
      this.setState({partnerResponse: null})
    }
  }
  render() {
    const { width } = this.state;
    const { PartnerDetailPageResponse } = this.props;
    let bannerContainer = null;
    if(width <= 576 && this.state.bg_mobile){
      bannerContainer = {
          "background": `url(${this.state.bg_mobile}) no-repeat`
      }
    }
    if(width <= 991 && width > 576 && this.state.bg_tablet){
        bannerContainer = {
            "background": `url(${this.state.bg_tablet}) no-repeat`
        }
    }
    if(width > 991 && this.state.bg_desktop){
        bannerContainer = {
            "background": `url(${this.state.bg_desktop}) no-repeat`
        }
    }

    return (
      <div className="partner-detail">
      <div className="body-background" style={bannerContainer}>
        {this.state && this.state.bannerTextBlock
          && <PartnerBanner bannerData={this.state.bannerTextBlock} partnerBlock={PartnerDetailPageResponse && PartnerDetailPageResponse.partner} />}
        
        {!this.props.match.params.product && PartnerDetailPageResponse && PartnerDetailPageResponse.partnerType === "multiCategory"
          && <PartnerProductCatagory {...this.props} />}

        {this.state.partnerResponse && this.props && (this.props.match.params.product || PartnerDetailPageResponse.partnerType === "singleCategory")
          && <PartnerProducts key="partnerProducts" {...this.props} changeProduct={this.changeProduct}/>}

        {this.props && PartnerDetailPageResponse && PartnerDetailPageResponse.partner.contact
          && <ContactWileyBlock contact={PartnerDetailPageResponse.partner.contact} /> }
      </div>
      </div>
    );
  }
}

export default Body;